<template>
  <b-modal
    id="editScheduleModal"
    size="md"
    modal-class="modal-datepicker"
    header-bg-variant="lisaweb"
    body-class="pt-3"
    footer-class="py-2 px-3"
    no-close-on-backdrop
    @show="load"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span>{{ isFailed ? "Reinvio procedura" : "Schedulazione invio" }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>

    <div v-if="isFailed" class="mb-3">
      L'invio della procedura è andato in errore. Indica quando riprovare.
    </div>

    <validation-observer ref="observer">
      <b-form @submit.prevent="">
        <base-datepicker
          vid="scheduled_date"
          name="data"
          label="Data invio"
          v-model="form.date"
          :rules="{ required: true }"
        />
        <base-timepicker
          vid="scheduled_time"
          name="ora"
          label="Ora invio"
          v-model="form.time"
          :rules="{ required: true }"
        />
        <b-alert v-if="isPast" show variant="warning" class="mt-2 mb-0 py-2">
          La data indicata è già passata: scegline una futura.
        </b-alert>
      </b-form>
    </validation-observer>

    <!--
      Tre esiti possibili (chiudi / annulla la schedulazione / salva la nuova
      data), quindi footer custom: showConfirm ne gestisce solo due e farebbe
      partire l'annullamento anche a una chiusura con Esc.
      Il pulsante non legge lo scope del validation-observer perché lo slot
      modal-footer deve restare figlio diretto di b-modal.
    -->
    <template #modal-footer="{ cancel }">
      <b-form-group class="mb-0">
        <div class="d-flex">
          <b-button
            @click="cancel()"
            class="btn--transparent mr-2"
            size="sm"
            variant="outline-secondary"
            >Chiudi
          </b-button>
          <b-button
            v-if="!isFailed"
            @click="onCancelSchedule(cancel)"
            class="mr-2"
            size="sm"
            variant="outline-lisaweb"
            title="Annulla l'invio programmato e libera le quietanze"
            >Annulla invio
          </b-button>
          <b-button
            @click="onSave(cancel)"
            size="sm"
            variant="lisaweb"
            :disabled="!canConfirm"
            >{{ isFailed ? "Riprogramma" : "Salva" }}
          </b-button>
        </div>
      </b-form-group>
    </template>
  </b-modal>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseTimepicker from "@/components/form/BaseTimepicker";
import moment from "moment";

/*
 * Modifica, annullamento e reinvio della schedulazione, dalla tabella delle
 * procedure.
 *
 * "ANNULLA INVIO" non compare sulle procedure in errore: lì non c'è nulla da
 * annullare, l'invio è già finito male e l'unica azione utile è riprogrammarlo.
 *
 * Le chiamate restano al parent, che deve aggiornare due sistemi in un ordine
 * preciso (prima LisaComunica, che è l'unico a poter rifiutare, poi LisaWeb).
 */
export default {
  name: "EditScheduleModal",
  components: { BaseIcon, BaseDatepicker, BaseTimepicker },
  props: {
    /* La procedura su cui si sta agendo, dalla riga della tabella */
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        date: null,
        time: null,
      },
    };
  },
  computed: {
    isFailed() {
      return this.item?.status_procedure?.value === 8;
    },
    scheduledAt() {
      if (!this.form.date || !this.form.time) {
        return null;
      }
      return moment(
        `${this.form.date} ${this.form.time}`,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DD HH:mm:ss");
    },
    isPast() {
      return (
        !!this.scheduledAt && moment(this.scheduledAt).isSameOrBefore(moment())
      );
    },
    canConfirm() {
      return !!this.scheduledAt && !this.isPast;
    },
  },
  methods: {
    /*
     * Ricarica i campi dalla schedulazione corrente a ogni apertura, non su un
     * watch dell'item: riaprendo la stessa riga il watch non scatterebbe e la
     * modale mostrerebbe le modifiche non salvate della volta precedente.
     */
    load() {
      const current = this.item?.scheduled_at;
      if (!current) {
        this.form.date = null;
        this.form.time = null;

        return;
      }
      const parsed = moment(current, "YYYY-MM-DD HH:mm:ss");
      this.form.date = parsed.format("YYYY-MM-DD");
      this.form.time = parsed.format("HH:mm");
    },
    onSave(cancel) {
      const scheduledAt = this.scheduledAt;
      cancel();
      this.$emit("save", scheduledAt);
    },
    onCancelSchedule(cancel) {
      cancel();
      this.$emit("cancel-schedule");
    },
  },
};
</script>
